import { useEffect } from "react";
import { useGetClientQuery } from "@/queries/useGetClientQuery";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Custom hook to get the full name of the current user
 * Updates auth context with userName from API
 * @returns Full name as "FirstName LastName" from auth context
 */
export const useUserName = () => {
  const { data: clientData } = useGetClientQuery();
  const { userName, setUserName } = useAuth();

  useEffect(() => {
    if (clientData && !userName) {
      const fullName = `${clientData.name} ${clientData.last_name}`;
      setUserName(fullName);
    }
  }, [clientData, userName, setUserName]);

  return userName;
};
